import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../../lib/supabaseClient';
import { generateAndCopy } from '../../utils/generatePassword';
import Navbar from '../../components/Navbar/Navbar';
import '../Catalogs/Catalogs.css';
import './AdminUsers.css';

const PAGE_SIZE = 30;
const SUPER_ADMIN_ID = '789c9a62-7e0b-4967-b0a9-7b53d7d4e367';

/* ── Helpers ──────────────────────────────────────── */
function getPageList(current, total) {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages = [];
  for (let i = 1; i <= total; i++) {
    if (i === 1 || i === total || (i >= current - 1 && i <= current + 1)) {
      pages.push(i);
    } else if (pages[pages.length - 1] !== '...') {
      pages.push('...');
    }
  }
  return pages;
}

/* ── Icons ────────────────────────────────────────── */
function IconBack() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

function IconPlus() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <line x1="12" y1="5" x2="12" y2="19" />
      <line x1="5" y1="12" x2="19" y2="12" />
    </svg>
  );
}

function IconSearch() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="11" cy="11" r="8" />
      <line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  );
}

function IconEdit() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7" />
      <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z" />
    </svg>
  );
}

function IconDeactivate() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <line x1="15" y1="9" x2="9" y2="15" />
      <line x1="9" y1="9" x2="15" y2="15" />
    </svg>
  );
}

function IconRestore() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="1 4 1 10 7 10" />
      <path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10" />
    </svg>
  );
}

function IconKey() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4" />
    </svg>
  );
}

function IconChevronLeft() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="15 18 9 12 15 6" />
    </svg>
  );
}

function IconChevronRight() {
  return (
    <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <polyline points="9 18 15 12 9 6" />
    </svg>
  );
}

function IconEye() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}

function IconEyeOff() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94" />
      <path d="M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19" />
      <line x1="1" y1="1" x2="23" y2="23" />
      <path d="M14.12 14.12a3 3 0 1 1-4.24-4.24" />
    </svg>
  );
}

function IconDice() {
  return (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <rect x="3" y="3" width="18" height="18" rx="3" />
      <circle cx="8.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="8.5" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="8.5" cy="15.5" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="15.5" cy="15.5" r="1.5" fill="currentColor" stroke="none" />
      <circle cx="12" cy="12" r="1.5" fill="currentColor" stroke="none" />
    </svg>
  );
}

/* ── Password Input with Toggle + optional Generate ── */
function PasswordInput({ value, onChange, hasError, placeholder, onGenerate }) {
  const [visible, setVisible] = useState(false);
  return (
    <div className={`usr-password-wrap${onGenerate ? ' usr-password-wrap--with-generate' : ''}`}>
      <input
        type={visible ? 'text' : 'password'}
        className={`cat-input${hasError ? ' cat-input--error' : ''}`}
        value={value}
        onChange={onChange}
        placeholder={placeholder || ''}
        autoComplete="new-password"
      />
      {onGenerate && (
        <button
          type="button"
          className="usr-password-generate"
          onClick={() => { onGenerate(); setVisible(true); }}
          tabIndex={-1}
          aria-label="Generar contraseña segura"
          title="Generar contraseña segura"
        >
          <IconDice />
        </button>
      )}
      <button
        type="button"
        className="usr-password-toggle"
        onClick={() => setVisible((v) => !v)}
        tabIndex={-1}
        aria-label={visible ? 'Ocultar contraseña' : 'Mostrar contraseña'}
      >
        {visible ? <IconEyeOff /> : <IconEye />}
      </button>
    </div>
  );
}

/* ── External Resource Toggle ─────────────────────── */
function ExternalToggle({ id, checked, onChange }) {
  return (
    <div className="usr-toggle-row">
      <label className="usr-toggle-label" htmlFor={id}>
        ¿Es Recurso Externo?
      </label>
      <button
        id={id}
        type="button"
        role="switch"
        aria-checked={checked}
        className={`usr-toggle${checked ? ' usr-toggle--on' : ''}`}
        onClick={() => onChange(!checked)}
      >
        <span className="usr-toggle-knob" />
      </button>
      <span className="usr-toggle-state">{checked ? 'Sí' : 'No'}</span>
    </div>
  );
}

/* ── Create User Modal ────────────────────────────── */
function CreateUserModal({ roles, allRoles, isSuperAdmin, onSave, onClose }) {
  const availableRoles = isSuperAdmin ? allRoles : roles;
  const [form, setForm] = useState({ email: '', full_name: '', role_id: '', password: '', confirmPassword: '', is_external: false });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [loading, setLoading] = useState(false);
  const [clipboardMsg, setClipboardMsg] = useState('');

  async function handleGenerate() {
    const pw = await generateAndCopy();
    setForm((prev) => ({ ...prev, password: pw, confirmPassword: pw }));
    setErrors((prev) => ({ ...prev, password: '', confirmPassword: '' }));
    setClipboardMsg('Contraseña generada y copiada al portapapeles');
    setTimeout(() => setClipboardMsg(''), 3000);
  }

  /* Only Desarrolladores can be external resources */
  const selectedRoleName = availableRoles.find((r) => String(r.id) === form.role_id)?.name;
  const isDesarrollador = selectedRoleName === 'Desarrollador';

  function handleChange(key, value) {
    setForm((prev) => {
      const next = { ...prev, [key]: value };
      /* Reset the external flag if the role moves away from Desarrollador */
      if (key === 'role_id') {
        const roleName = availableRoles.find((r) => String(r.id) === value)?.name;
        if (roleName !== 'Desarrollador') next.is_external = false;
      }
      return next;
    });
    if (errors[key]) setErrors((prev) => ({ ...prev, [key]: '' }));
    if (submitError) setSubmitError('');
  }

  function validate() {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Este campo es requerido.';
    if (!form.email.trim()) {
      e.email = 'Este campo es requerido.';
    } else if (!form.email.trim().endsWith('@wsp.com.mx')) {
      e.email = 'El correo debe ser del dominio @wsp.com.mx';
    }
    if (!form.role_id) e.role_id = 'Selecciona un rol.';
    if (!form.password) {
      e.password = 'Este campo es requerido.';
    } else if (form.password.length < 6) {
      e.password = 'Mínimo 6 caracteres.';
    }
    if (!form.confirmPassword) {
      e.confirmPassword = 'Confirma la contraseña.';
    } else if (form.password !== form.confirmPassword) {
      e.confirmPassword = 'Las contraseñas no coinciden.';
    }
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      await onSave({
        email: form.email.trim().toLowerCase(),
        full_name: form.full_name.trim(),
        role_id: Number(form.role_id),
        password: form.password,
        is_external: isDesarrollador && form.is_external,
      });
    } catch (err) {
      setSubmitError(err.message || 'No se pudo crear el usuario. Verifica los datos e intenta de nuevo.');
      setLoading(false);
    }
  }

  return (
    <>
      <div className="cat-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="cat-modal" role="dialog" aria-modal="true" aria-labelledby="create-user-title">
        <h2 id="create-user-title" className="cat-modal-title">Nuevo Usuario</h2>
        <form className="cat-modal-form" onSubmit={handleSubmit} noValidate>
          <div className="cat-form-group">
            <label className="cat-form-label" htmlFor="create-user-full-name">
              Nombre Completo <span className="cat-required"> *</span>
            </label>
            <p id="create-user-full-name-hint" className="usr-form-hint">
              Escribe únicamente primer nombre, apellido paterno y materno; si el usuario tiene 2 nombres, solo escoge y escribe uno.
            </p>
            <input
              id="create-user-full-name"
              type="text"
              className={`cat-input${errors.full_name ? ' cat-input--error' : ''}`}
              value={form.full_name}
              onChange={(e) => handleChange('full_name', e.target.value)}
              aria-describedby={
                errors.full_name
                  ? 'create-user-full-name-hint create-user-full-name-error'
                  : 'create-user-full-name-hint'
              }
            />
            {errors.full_name && (
              <span id="create-user-full-name-error" className="cat-form-error">
                {errors.full_name}
              </span>
            )}
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Correo Electrónico <span className="cat-required"> *</span>
            </label>
            <input
              type="email"
              className={`cat-input${errors.email ? ' cat-input--error' : ''}`}
              value={form.email}
              onChange={(e) => handleChange('email', e.target.value)}
              placeholder="usuario@wsp.com.mx"
            />
            {errors.email && <span className="cat-form-error">{errors.email}</span>}
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Rol <span className="cat-required"> *</span>
            </label>
            <select
              className={`cat-select${errors.role_id ? ' cat-input--error' : ''}`}
              value={form.role_id}
              onChange={(e) => handleChange('role_id', e.target.value)}
            >
              <option value="">Seleccionar…</option>
              {availableRoles.map((r) => (
                <option key={r.id} value={String(r.id)}>{r.name}</option>
              ))}
            </select>
            {errors.role_id && <span className="cat-form-error">{errors.role_id}</span>}
          </div>

          {isDesarrollador && (
            <div className="cat-form-group">
              <ExternalToggle
                id="create-user-external"
                checked={form.is_external}
                onChange={(v) => handleChange('is_external', v)}
              />
            </div>
          )}

          <div className="cat-form-group">
            <label className="cat-form-label">
              Contraseña <span className="cat-required"> *</span>
            </label>
            <PasswordInput
              value={form.password}
              onChange={(e) => handleChange('password', e.target.value)}
              hasError={!!errors.password}
              placeholder="Mínimo 6 caracteres"
              onGenerate={handleGenerate}
            />
            {errors.password && <span className="cat-form-error">{errors.password}</span>}
            {clipboardMsg && <span className="usr-clipboard-msg">{clipboardMsg}</span>}
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Confirmar Contraseña <span className="cat-required"> *</span>
            </label>
            <PasswordInput
              value={form.confirmPassword}
              onChange={(e) => handleChange('confirmPassword', e.target.value)}
              hasError={!!errors.confirmPassword}
            />
            {errors.confirmPassword && <span className="cat-form-error">{errors.confirmPassword}</span>}
          </div>

          {submitError && (
            <div className="cat-error-banner" role="alert">{submitError}</div>
          )}

          <div className="cat-modal-actions">
            <button type="button" className="cat-btn-cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="cat-btn-primary" disabled={loading}>
              {loading ? (
                <><span className="cat-spinner" aria-hidden="true" />Creando…</>
              ) : 'Crear Usuario'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

/* ── Edit User Modal ──────────────────────────────── */
function EditUserModal({ user, roles, allRoles, isSuperAdmin, onSave, onClose }) {
  /* Lock the role field when editing:
     - the super admin account (rh@wsp.com.mx) — nobody can change it, not even itself
     - any Gerente user — unless the caller is the super admin */
  const isTargetSuperAdmin = user.id === SUPER_ADMIN_ID;
  const isTargetGerente = user.role_name === 'Gerente';
  const roleEditable = !isTargetSuperAdmin && (!isTargetGerente || isSuperAdmin);
  /* Super admin sees all roles in dropdown; regular Gerente sees only Líder / Desarrollador */
  const availableRoles = isSuperAdmin ? allRoles : roles;

  const [form, setForm] = useState({
    full_name: user.full_name || '',
    role_id: String(user.role_id),
    is_external: !!user.is_external,
  });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [loading, setLoading] = useState(false);

  /* Only Desarrolladores can be external resources */
  const selectedRoleName = roleEditable
    ? availableRoles.find((r) => String(r.id) === form.role_id)?.name
    : user.role_name;
  const isDesarrollador = selectedRoleName === 'Desarrollador';

  function handleChange(key, value) {
    setForm((prev) => {
      const next = { ...prev, [key]: value };
      /* Reset the external flag if the role moves away from Desarrollador */
      if (key === 'role_id') {
        const roleName = availableRoles.find((r) => String(r.id) === value)?.name;
        if (roleName !== 'Desarrollador') next.is_external = false;
      }
      return next;
    });
    if (errors[key]) setErrors((prev) => ({ ...prev, [key]: '' }));
    if (submitError) setSubmitError('');
  }

  function validate() {
    const e = {};
    if (!form.full_name.trim()) e.full_name = 'Este campo es requerido.';
    if (roleEditable && !form.role_id) e.role_id = 'Selecciona un rol.';
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    const updates = {
      full_name: form.full_name.trim(),
      is_external: isDesarrollador && form.is_external,
    };
    if (roleEditable) updates.role_id = Number(form.role_id);
    try {
      await onSave(user.id, updates);
    } catch {
      setSubmitError('No se pudo guardar. Verifica los datos e intenta de nuevo.');
      setLoading(false);
    }
  }

  return (
    <>
      <div className="cat-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="cat-modal" role="dialog" aria-modal="true" aria-labelledby="edit-user-title">
        <h2 id="edit-user-title" className="cat-modal-title">Editar Usuario</h2>
        <form className="cat-modal-form" onSubmit={handleSubmit} noValidate>
          <div className="cat-form-group">
            <label className="cat-form-label">Correo Electrónico</label>
            <input type="text" className="cat-input" value={user.email} disabled />
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Nombre Completo <span className="cat-required"> *</span>
            </label>
            <input
              type="text"
              className={`cat-input${errors.full_name ? ' cat-input--error' : ''}`}
              value={form.full_name}
              onChange={(e) => handleChange('full_name', e.target.value)}
            />
            {errors.full_name && <span className="cat-form-error">{errors.full_name}</span>}
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Rol {roleEditable && <span className="cat-required"> *</span>}
            </label>
            {roleEditable ? (
              <select
                className={`cat-select${errors.role_id ? ' cat-input--error' : ''}`}
                value={form.role_id}
                onChange={(e) => handleChange('role_id', e.target.value)}
              >
                <option value="">Seleccionar…</option>
                {availableRoles.map((r) => (
                  <option key={r.id} value={String(r.id)}>{r.name}</option>
                ))}
              </select>
            ) : (
              <input type="text" className="cat-input" value={user.role_name} disabled />
            )}
            {errors.role_id && <span className="cat-form-error">{errors.role_id}</span>}
          </div>

          {isDesarrollador && (
            <div className="cat-form-group">
              <ExternalToggle
                id="edit-user-external"
                checked={form.is_external}
                onChange={(v) => handleChange('is_external', v)}
              />
            </div>
          )}

          {submitError && (
            <div className="cat-error-banner" role="alert">{submitError}</div>
          )}

          <div className="cat-modal-actions">
            <button type="button" className="cat-btn-cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="cat-btn-primary" disabled={loading}>
              {loading ? (
                <><span className="cat-spinner" aria-hidden="true" />Guardando…</>
              ) : 'Guardar'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

/* ── Reset Password Modal ─────────────────────────── */
function ResetPasswordModal({ user, onSave, onClose }) {
  const [form, setForm] = useState({ password: '', confirmPassword: '' });
  const [errors, setErrors] = useState({});
  const [submitError, setSubmitError] = useState('');
  const [loading, setLoading] = useState(false);
  const [clipboardMsg, setClipboardMsg] = useState('');

  async function handleGenerate() {
    const pw = await generateAndCopy();
    setForm({ password: pw, confirmPassword: pw });
    setErrors({});
    setClipboardMsg('Contraseña generada y copiada al portapapeles');
    setTimeout(() => setClipboardMsg(''), 3000);
  }

  function handleChange(key, value) {
    setForm((prev) => ({ ...prev, [key]: value }));
    if (errors[key]) setErrors((prev) => ({ ...prev, [key]: '' }));
    if (submitError) setSubmitError('');
  }

  function validate() {
    const e = {};
    if (!form.password) {
      e.password = 'Este campo es requerido.';
    } else if (form.password.length < 6) {
      e.password = 'Mínimo 6 caracteres.';
    }
    if (!form.confirmPassword) {
      e.confirmPassword = 'Confirma la contraseña.';
    } else if (form.password !== form.confirmPassword) {
      e.confirmPassword = 'Las contraseñas no coinciden.';
    }
    return e;
  }

  async function handleSubmit(e) {
    e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setLoading(true);
    try {
      await onSave(user.id, form.password);
    } catch (err) {
      setSubmitError(err.message || 'No se pudo restablecer la contraseña.');
      setLoading(false);
    }
  }

  return (
    <>
      <div className="cat-backdrop" onClick={onClose} aria-hidden="true" />
      <div className="cat-modal" role="dialog" aria-modal="true" aria-labelledby="reset-pw-title">
        <h2 id="reset-pw-title" className="cat-modal-title">Restablecer Contraseña</h2>
        <div className="usr-reset-user-info">
          <span className="usr-reset-label">Usuario:</span>
          <span className="usr-reset-value">{user.full_name}</span>
          <span className="usr-reset-email">{user.email}</span>
        </div>
        <form className="cat-modal-form" onSubmit={handleSubmit} noValidate>
          <div className="cat-form-group">
            <label className="cat-form-label">
              Nueva Contraseña <span className="cat-required"> *</span>
            </label>
            <PasswordInput
              value={form.password}
              onChange={(e) => handleChange('password', e.target.value)}
              hasError={!!errors.password}
              placeholder="Mínimo 6 caracteres"
              onGenerate={handleGenerate}
            />
            {errors.password && <span className="cat-form-error">{errors.password}</span>}
            {clipboardMsg && <span className="usr-clipboard-msg">{clipboardMsg}</span>}
          </div>

          <div className="cat-form-group">
            <label className="cat-form-label">
              Confirmar Contraseña <span className="cat-required"> *</span>
            </label>
            <PasswordInput
              value={form.confirmPassword}
              onChange={(e) => handleChange('confirmPassword', e.target.value)}
              hasError={!!errors.confirmPassword}
            />
            {errors.confirmPassword && <span className="cat-form-error">{errors.confirmPassword}</span>}
          </div>

          {submitError && (
            <div className="cat-error-banner" role="alert">{submitError}</div>
          )}

          <div className="cat-modal-actions">
            <button type="button" className="cat-btn-cancel" onClick={onClose} disabled={loading}>
              Cancelar
            </button>
            <button type="submit" className="cat-btn-primary" disabled={loading}>
              {loading ? (
                <><span className="cat-spinner" aria-hidden="true" />Restableciendo…</>
              ) : 'Restablecer'}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

/* ── Success Toast ────────────────────────────────── */
function SuccessToast({ message, onDone }) {
  useEffect(() => {
    const timer = setTimeout(onDone, 4000);
    return () => clearTimeout(timer);
  }, [onDone]);

  return (
    <div className="usr-toast" role="status">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
        <polyline points="22 4 12 14.01 9 11.01" />
      </svg>
      {message}
    </div>
  );
}

/* ══════════════════════════════════════════════════════
   MAIN COMPONENT
   ══════════════════════════════════════════════════════ */
function AdminUsers() {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);

  /* Current logged-in user */
  const [currentUserId, setCurrentUserId] = useState(null);
  const isSuperAdmin = currentUserId === SUPER_ADMIN_ID;

  /* Modal states */
  const [createOpen, setCreateOpen] = useState(false);
  const [editUser, setEditUser] = useState(null);
  const [resetUser, setResetUser] = useState(null);
  const [confirmRow, setConfirmRow] = useState(null);
  const [actionLoading, setActionLoading] = useState(false);
  const [toast, setToast] = useState('');

  /* Role options: standard (Líder + Desarrollador) and all (includes Gerente) */
  const [roles, setRoles] = useState([]);
  const [allRoles, setAllRoles] = useState([]);

  useEffect(() => {
    fetchCurrentUser();
    fetchUsers();
    fetchRoles();
  }, []);

  useEffect(() => {
    setPage(1);
  }, [search]);

  async function fetchCurrentUser() {
    const { data: { user } } = await supabase.auth.getUser();
    if (user) setCurrentUserId(user.id);
  }

  async function fetchUsers() {
    setLoading(true);
    const { data, error } = await supabase.rpc('get_users_with_email');
    if (!error) setUsers(data || []);
    setLoading(false);
  }

  async function fetchRoles() {
    const { data } = await supabase
      .from('roles')
      .select('id, name')
      .order('name');
    setAllRoles(data || []);
    setRoles((data || []).filter((r) => r.name !== 'Gerente'));
  }

  /* ── Create user via edge function ── */
  async function handleCreateUser(formData) {
    const { data, error } = await supabase.functions.invoke('manage-users', {
      body: { action: 'create', ...formData },
    });
    if (error) throw new Error(error.message || 'Error al crear usuario');
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    if (parsed.error) throw new Error(parsed.error);
    setCreateOpen(false);
    setToast('Usuario creado exitosamente');
    fetchUsers();

    // Fire-and-forget: send new user notification via Power Automate
    const roleName = allRoles.find((r) => r.id === formData.role_id)?.name || '';
    supabase.functions.invoke('send-notification', {
      body: {
        notification_type: 'new_user',
        payload: {
          email: formData.email,
          full_name: formData.full_name,
          role: roleName,
          password: formData.password,
        },
      },
    }).catch(() => { /* notification failure should not affect the user */ });
  }

  /* ── Edit user (full_name + role_id) via direct update ── */
  async function handleEditUser(userId, updates) {
    const { error } = await supabase
      .from('users')
      .update({ ...updates, updated_at: new Date().toISOString() })
      .eq('id', userId);
    if (error) throw error;
    setEditUser(null);
    setToast('Usuario actualizado exitosamente');
    fetchUsers();
  }

  /* ── Deactivate / Reactivate ── */
  async function handleDeactivate() {
    if (!confirmRow) return;
    setActionLoading(true);
    const { data, error } = await supabase.functions.invoke('manage-users', {
      body: { action: 'deactivate', user_id: confirmRow.id },
    });
    setActionLoading(false);
    setConfirmRow(null);
    if (error) {
      setToast('Error al desactivar el usuario.');
    } else {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;
      if (parsed?.error) {
        setToast(`Error: ${parsed.error}`);
      } else {
        setToast('Usuario desactivado');
        fetchUsers();
      }
    }
  }

  async function handleReactivate(row) {
    const { data, error } = await supabase.functions.invoke('manage-users', {
      body: { action: 'reactivate', user_id: row.id },
    });
    if (error) {
      setToast('Error al reactivar el usuario.');
    } else {
      const parsed = typeof data === 'string' ? JSON.parse(data) : data;
      if (parsed?.error) {
        setToast(`Error: ${parsed.error}`);
      } else {
        setToast('Usuario reactivado');
        fetchUsers();
      }
    }
  }

  /* ── Reset password via edge function ── */
  async function handleResetPassword(userId, newPassword) {
    const { data, error } = await supabase.functions.invoke('manage-users', {
      body: { action: 'reset-password', user_id: userId, new_password: newPassword },
    });
    if (error) throw new Error(error.message || 'Error al restablecer contraseña');
    const parsed = typeof data === 'string' ? JSON.parse(data) : data;
    if (parsed.error) throw new Error(parsed.error);
    setResetUser(null);
    setToast('Contraseña restablecida exitosamente');

    // Fire-and-forget: notify the user of their new password via Power Automate
    const targetUser = users.find((u) => u.id === userId);
    if (targetUser) {
      supabase.functions.invoke('send-notification', {
        body: {
          notification_type: 'admin_password_reset',
          payload: {
            email: targetUser.email,
            full_name: targetUser.full_name,
            new_password: newPassword,
          },
        },
      }).catch(() => { /* notification failure should not affect the user */ });
    }
  }

  /* ── Derived data ── */
  const filteredUsers = users.filter((u) => {
    if (!search.trim()) return true;
    const s = search.toLowerCase();
    return (
      (u.full_name || '').toLowerCase().includes(s) ||
      (u.email || '').toLowerCase().includes(s) ||
      (u.role_name || '').toLowerCase().includes(s) ||
      (u.is_external ? 'externo' : 'interno').includes(s)
    );
  });

  const totalPages = Math.max(1, Math.ceil(filteredUsers.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages);
  const paginatedUsers = filteredUsers.slice((safePage - 1) * PAGE_SIZE, safePage * PAGE_SIZE);
  const pageList = getPageList(safePage, totalPages);

  function countLabel() {
    if (search.trim() && filteredUsers.length !== users.length) {
      return `Se encontraron ${filteredUsers.length} de ${users.length} usuarios`;
    }
    return `Se encontraron ${users.length} usuario${users.length !== 1 ? 's' : ''}`;
  }

  return (
    <div className="cat-page">
      <Navbar />

      <main className="cat-main">
        <div className="cat-crud">
          {/* ── Header ── */}
          <div className="cat-crud-header">
            <button className="cat-back-btn" onClick={() => navigate('/admin')}>
              <IconBack />
              <span>Regresar</span>
            </button>
            <h1 className="cat-crud-title">Administración de Usuarios</h1>
            <button
              className="cat-new-btn"
              onClick={() => setCreateOpen(true)}
            >
              <IconPlus />
              <span>Nuevo</span>
            </button>
          </div>

          {/* ── Search + count ── */}
          <div className="cat-toolbar">
            <div className="cat-search-wrap">
              <IconSearch />
              <input
                type="text"
                className="cat-search"
                placeholder="Buscar por nombre, correo, rol o tipo…"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>
            {!loading && (
              <span className="cat-count">{countLabel()}</span>
            )}
          </div>

          {/* ── Table ── */}
          {loading ? (
            <div className="cat-loading">Cargando usuarios…</div>
          ) : filteredUsers.length === 0 ? (
            <div className="cat-empty">
              {search ? 'No se encontraron resultados.' : 'No hay usuarios registrados.'}
            </div>
          ) : (
            <>
              <div className="cat-table-wrap">
                <table className="cat-table">
                  <thead>
                    <tr>
                      <th>Nombre Completo</th>
                      <th>Correo Electrónico</th>
                      <th>Rol</th>
                      <th>Tipo</th>
                      <th>Último Acceso</th>
                      <th>Estado</th>
                      <th>Acciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginatedUsers.map((u) => (
                      <tr key={u.id} className={u.active ? '' : 'cat-row--inactive'}>
                        <td>{u.full_name}</td>
                        <td>{u.email}</td>
                        <td>
                          <span className={`usr-role-badge usr-role-badge--${u.role_name?.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g, '')}`}>
                            {u.role_name}
                          </span>
                        </td>
                        <td>
                          <span className={`usr-type-badge ${u.is_external ? 'usr-type-badge--externo' : 'usr-type-badge--interno'}`}>
                            {u.is_external ? 'Externo' : 'Interno'}
                          </span>
                        </td>
                        <td>
                          {u.last_sign_in_at
                            ? new Date(u.last_sign_in_at).toLocaleString('es-MX', {
                                day: '2-digit', month: '2-digit', year: 'numeric',
                                hour: '2-digit', minute: '2-digit', hour12: false,
                              })
                            : <span style={{ color: 'rgba(34,34,34,0.4)' }}>Nunca</span>
                          }
                        </td>
                        <td>
                          <span className={`cat-badge ${u.active ? 'cat-badge--active' : 'cat-badge--inactive'}`}>
                            {u.active ? 'Activo' : 'Inactivo'}
                          </span>
                        </td>
                        <td>
                          <div className="cat-actions">
                            <button
                              className="cat-action-btn cat-action-edit"
                              onClick={() => setEditUser(u)}
                              title="Editar"
                            >
                              <IconEdit />
                            </button>
                            {u.id === currentUserId ? (
                              /* Cannot deactivate own account */
                              <button
                                className="cat-action-btn cat-action-delete"
                                disabled
                                title="No puedes desactivar tu propia cuenta"
                              >
                                <IconDeactivate />
                              </button>
                            ) : u.active ? (
                              <button
                                className="cat-action-btn cat-action-delete"
                                onClick={() => setConfirmRow(u)}
                                title="Desactivar"
                              >
                                <IconDeactivate />
                              </button>
                            ) : (
                              <button
                                className="cat-action-btn cat-action-restore"
                                onClick={() => handleReactivate(u)}
                                title="Reactivar"
                              >
                                <IconRestore />
                              </button>
                            )}
                            <button
                              className="cat-action-btn usr-action-key"
                              onClick={() => setResetUser(u)}
                              title="Restablecer Contraseña"
                            >
                              <IconKey />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* ── Pagination ── */}
              {totalPages > 1 && (
                <div className="cat-pagination-wrap">
                  <span className="cat-page-info">
                    Página {safePage} de {totalPages}
                  </span>
                  <div className="cat-pagination">
                    <button
                      className="cat-page-nav"
                      onClick={() => setPage((p) => Math.max(1, p - 1))}
                      disabled={safePage === 1}
                      aria-label="Página anterior"
                    >
                      <IconChevronLeft />
                    </button>
                    {pageList.map((item, i) =>
                      item === '...' ? (
                        <span key={`ellipsis-${i}`} className="cat-page-ellipsis">…</span>
                      ) : (
                        <button
                          key={item}
                          className={`cat-page-btn${safePage === item ? ' cat-page-btn--active' : ''}`}
                          onClick={() => setPage(item)}
                          aria-current={safePage === item ? 'page' : undefined}
                        >
                          {item}
                        </button>
                      )
                    )}
                    <button
                      className="cat-page-nav"
                      onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
                      disabled={safePage === totalPages}
                      aria-label="Página siguiente"
                    >
                      <IconChevronRight />
                    </button>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </main>

      {/* ── Modals ── */}
      {createOpen && (
        <CreateUserModal
          roles={roles}
          allRoles={allRoles}
          isSuperAdmin={isSuperAdmin}
          onSave={handleCreateUser}
          onClose={() => setCreateOpen(false)}
        />
      )}

      {editUser && (
        <EditUserModal
          user={editUser}
          roles={roles}
          allRoles={allRoles}
          isSuperAdmin={isSuperAdmin}
          onSave={handleEditUser}
          onClose={() => setEditUser(null)}
        />
      )}

      {resetUser && (
        <ResetPasswordModal
          user={resetUser}
          onSave={handleResetPassword}
          onClose={() => setResetUser(null)}
        />
      )}

      {/* ── Deactivate confirmation ── */}
      {confirmRow && (
        <>
          <div className="cat-backdrop" onClick={() => setConfirmRow(null)} aria-hidden="true" />
          <div className="cat-confirm" role="alertdialog" aria-modal="true">
            <h3 className="cat-confirm-title">¿Desactivar usuario?</h3>
            <p className="cat-confirm-msg">
              <strong>{confirmRow.full_name}</strong> ({confirmRow.email}) será desactivado y no podrá iniciar sesión.
              Podrás reactivarlo después.
            </p>
            <div className="cat-confirm-actions">
              <button
                className="cat-btn-cancel"
                onClick={() => setConfirmRow(null)}
                disabled={actionLoading}
              >
                Cancelar
              </button>
              <button
                className="cat-btn-danger"
                onClick={handleDeactivate}
                disabled={actionLoading}
              >
                {actionLoading ? 'Desactivando…' : 'Desactivar'}
              </button>
            </div>
          </div>
        </>
      )}

      {/* ── Toast ── */}
      {toast && <SuccessToast message={toast} onDone={() => setToast('')} />}
    </div>
  );
}

export default AdminUsers;
